import {
    CalendarDaysIcon,
    CheckCircleIcon,
    EyeSlashIcon,
    UsersIcon
} from '@heroicons/react/24/outline';
import { StatCard } from '../billing/StatusCards';
import type { EventStatus } from './eventStatus';

/** The three statuses worth a one-click filter. `past` is the residue and gets none. */
export type EventQuickStat = Extract<EventStatus, 'active' | 'upcoming' | 'disabled'>;

interface EventStatCardsProps {
    counts: Record<EventStatus, number>;
    /** Live sign-ups across every event, cancelled excluded. */
    totalSignups: number;
    active: EventQuickStat | null;
    onToggle: (stat: EventQuickStat) => void;
}

/**
 * Same clickable filter cards as the billing pages (DiscountsPage, ProductsTable)
 * and Practices: click to filter, click again to clear. The sign-up card is
 * static - there is no "filter by has sign-ups", and inventing one would be a
 * card that lies about being clickable.
 */
export function EventStatCards({ counts, totalSignups, active, onToggle }: EventStatCardsProps) {
    return (
        <div className="flex items-stretch gap-3 px-8 pt-4 shrink-0">
            <StatCard
                label="Live now"
                icon={<CheckCircleIcon className="h-3.5 w-3.5" />}
                value={String(counts.active)}
                unit="banner showing"
                isActive={active === 'active'}
                onClick={() => onToggle('active')}
            />
            <StatCard
                label="Upcoming"
                icon={<CalendarDaysIcon className="h-3.5 w-3.5" />}
                value={String(counts.upcoming)}
                unit="window not open yet"
                isActive={active === 'upcoming'}
                onClick={() => onToggle('upcoming')}
            />
            <StatCard
                label="Disabled"
                icon={<EyeSlashIcon className="h-3.5 w-3.5" />}
                value={String(counts.disabled)}
                unit="never shown"
                isActive={active === 'disabled'}
                onClick={() => onToggle('disabled')}
            />
            <StatCard
                label="Sign-ups"
                icon={<UsersIcon className="h-3.5 w-3.5" />}
                value={String(totalSignups)}
                unit="across all events"
                isActive={false}
                onClick={() => {}}
            />
        </div>
    );
}
